import React from 'react'
import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

export type IconInfoProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

// This component is needed because the design CMS tooltips don't work on inversedColors, nor have a color / className override setting
export const IconInfo: React.FC<IconInfoProps> = ({ ...props }) => {
  return (
    <MySvgIcon width="21px" viewBox="0 0 21 17" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm1-3.7V6.4H7v5.9h2zM7 4.9c0 .6.3.9 1 .9s1-.3 1-.9c0-.3-.1-.5-.2-.7-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.1.2-.2.4-.2.7z" />
      </g>
    </MySvgIcon>
  )
}
